/**
 * Layout del entorno FINANCIACIÓN. Sub-tabs "Leasings" y "Préstamos".
 * Vista solo de consulta y exportación (los cuadros se mantienen desde
 * la ficha de empresa en /proveedores/:companyId).
 */
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { Car, Landmark, LogOut } from "lucide-react";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";
import BackButton from "@/components/BackButton";

const tabClass = ({ isActive }: { isActive: boolean }) =>
  cn(
    "inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium rounded-md transition-colors border",
    isActive
      ? "bg-primary text-primary-foreground border-primary"
      : "bg-background text-muted-foreground border-transparent hover:bg-muted hover:text-foreground",
  );

const FinanciacionLayout = () => {
  const { signOut } = useAuth();
  const navigate = useNavigate();

  const handleSignOut = async () => {
    await signOut();
    navigate("/login", { replace: true });
  };

  return (
    <div className="flex flex-col min-h-[calc(100vh-2.25rem)]">
      <nav className="border-b bg-muted/30 px-4 py-2 flex flex-wrap items-center justify-between gap-2">
        <div className="flex flex-wrap items-center gap-2 min-w-0">
          <BackButton variant="ghost" className="text-xs" />
          <span className="text-[10px] uppercase tracking-wider text-muted-foreground mr-2">
            Financiación
          </span>
          <NavLink to="/financiacion/leasings" className={tabClass}>
            <Car className="h-3.5 w-3.5" />
            Leasings
          </NavLink>
          <NavLink to="/financiacion/prestamos" className={tabClass}>
            <Landmark className="h-3.5 w-3.5" />
            Préstamos
          </NavLink>
        </div>
        <Button variant="ghost" size="sm" onClick={handleSignOut} className="gap-2 text-xs">
          <LogOut className="h-3.5 w-3.5" />
          Salir
        </Button>
      </nav>
      <div className="flex-1 min-w-0">
        <Outlet />
      </div>
    </div>
  );
};

export default FinanciacionLayout;
